var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260.349,
    height: 255.747,
    viewBox: "0 0 260.349 255.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.614,
    y1: 93.381,
    x2: 5.038,
    y2: 93.381,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -9.665,
    y1: 42.156,
    x2: -9.419,
    y2: 42.156,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.941,
    y1: 11.458,
    x2: -0.908,
    y2: 11.458,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -37.629,
    y1: 48.797,
    x2: -37.352,
    y2: 48.797,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -40.585,
    y1: 47.069,
    x2: -40.308,
    y2: 47.069,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Concepct1",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_527",
    d: "M104.89,109.04H.44V17.69H139.32v39.5",
    fill: "none",
    stroke: "#cac8c8",
    strokeLinecap: "round",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    x2: 138.85,
    transform: "translate(0.44 22.54)",
    fill: "none",
    stroke: "#cac8c8",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    width: 41.74,
    height: 41.74,
    transform: "translate(10.54 30.69)",
    fill: "none",
    stroke: "#adadad",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    x2: 63.8,
    transform: "translate(60.28 34.37)",
    fill: "none",
    stroke: "#adadad",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    x2: 63.8,
    transform: "translate(60.28 40.66)",
    fill: "none",
    stroke: "#adadad",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    x2: 63.8,
    transform: "translate(60.28 46.96)",
    fill: "none",
    stroke: "#adadad",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    x2: 63.8,
    transform: "translate(60.28 53.25)",
    fill: "none",
    stroke: "#adadad",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    d: "M31.42,41.72,20.04,61.4H42.78L31.43,41.72Z",
    fill: "#b8b6b6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(2.27 19.01)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(6.36 19.01)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(10.41 19.01)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    width: 62.21,
    height: 96.34,
    transform: "translate(107.93 59.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    x2: 56.79,
    transform: "translate(128.72 114.45)",
    fill: "none",
    stroke: "#cac8c8",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    x2: 56.79,
    transform: "translate(128.72 120.75)",
    fill: "none",
    stroke: "#cac8c8",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    cx: 16.27,
    cy: 16.27,
    r: 16.27,
    transform: "translate(122.78 71.6)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    d: "M61.6,92.76l3.94-3.47H61.51l.09,3.47Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_525",
    d: "M64.35,76.28H81.41a6.69,6.69,0,0,1,6.69,6.69h0a6.69,6.69,0,0,1-6.69,6.69H64.35a6.69,6.69,0,0,1-6.69-6.69h0A6.69,6.69,0,0,1,64.35,76.28Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(67.63 81.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(71.72 81.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(75.78 81.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    d: "M205.93,92.57l-3.94-3.5h4.03Z",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_526",
    d: "M186.12,76.1h17.06a6.69,6.69,0,0,1,6.69,6.69h0a6.69,6.69,0,0,1-6.69,6.69H186.12a6.69,6.69,0,0,1-6.69-6.69h0A6.69,6.69,0,0,1,186.12,76.1Z",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(197.55 81.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(193.49 81.59)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    cx: 1.18,
    cy: 1.18,
    r: 1.18,
    transform: "translate(189.4 81.59)",
    fill: "#fafbfc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    cx: 1.82,
    cy: 1.82,
    r: 1.82,
    transform: "translate(158.74 57.56)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    cx: 1.82,
    cy: 1.82,
    r: 1.82,
    transform: "translate(169.5 63.85)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    d: "M168.29,153.09a12.967,12.967,0,0,1-2.38-6.71",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    d: "M150.88,152.88c2.77.21,6.23.32,8.68,2",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.36
  }), /*#__PURE__*/React.createElement("g", {
    id: "CHAIR"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    d: "M42.69,202.48l18.33,19.74a8.513,8.513,0,0,1,3.29,6.77v20.8a4.769,4.769,0,0,1-4.77,4.77H35.71",
    fill: "none",
    stroke: "#ffb000",
    strokeLinecap: "round",
    strokeWidth: 2.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    d: "M64.25,199.33h0a3.124,3.124,0,0,1-3.09,3.15H15.86a9.212,9.212,0,0,1-9.18-9.21V157.35a6.306,6.306,0,0,1,6.27-6.27H36.18a4.289,4.289,0,0,1,4.29,4.29h0v31.62a9.154,9.154,0,0,0,9.12,9.18H61.12a3.124,3.124,0,0,1,3.12,3.12v.03h0Z",
    fill: "#fff",
    stroke: "#ffb000",
    strokeLinecap: "round",
    strokeWidth: 2.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    d: "M64.13,200.21a3.159,3.159,0,0,1-3,2.27H15.86a9.212,9.212,0,0,1-9.18-9.21V157.35a6.289,6.289,0,0,1,3.44-5.59,6.417,6.417,0,0,0-1,3.38v37.33a7.8,7.8,0,0,0,7.8,7.8H63.57l.55-.06Z",
    fill: "#f0e1d4",
    stroke: "#ffb000",
    strokeLinecap: "round",
    strokeWidth: 2.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    d: "M40.6,174.74h8.59a15.1,15.1,0,0,1,15.06,15.09v10.44",
    fill: "none",
    stroke: "#ffb000",
    strokeLinecap: "round",
    strokeWidth: 2.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    d: "M22.83,202.48l18.33,19.74a8.522,8.522,0,0,1,3.3,6.77v20.8a4.769,4.769,0,0,1-4.77,4.77H15.86",
    fill: "none",
    stroke: "#ffb000",
    strokeLinecap: "round",
    strokeWidth: 2.37
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_HAND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HAND",
    d: "M43.1,127.23s8.56-1.27,13.74,10c4.5,9.85,7.85,19.06,7.85,19.06a136.473,136.473,0,0,0,18.68,8.06v5.59s-17.85,1.03-23.8,0c-4.38-.77-16.47-16.97-17.3-27.98s.83-14.74.83-14.74Z",
    fill: "#374486"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ARM",
    d: "M81.02,169.89c-.68-.15-.18-2.21.21-3.47a2.249,2.249,0,0,1,1.41-1.35,10.052,10.052,0,0,1,5.03-.65,7.34,7.34,0,0,1,4.41,2.71c.35.41,2.06,2.35,2.06,2.88l-13.12-.12Z",
    fill: "#fab6ad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "TORSO",
    d: "M34.89,122.7c-7.41.77-21.68,9.74-19.33,42.71,1.53,21.06,15.35,31.65,17.03,30.92s30.06-14.71,23.56-22.24-4.21-12.71-3.23-22.44,2.47-20.35-5.44-24.03c-12.82-5.94-10.62-5.12-12.59-4.91Z",
    fill: "#3f4d90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_LEG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHOES"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    d: "M94.13,254.37H73.92c-.03-.32-.03-.62-.03-.91H94.16a5.54,5.54,0,0,1-.03.91Z",
    fill: "#383c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    d: "M75.98,244.95c.06,2.29-2.06,3.74-2.06,8.5H94.13a4.706,4.706,0,0,0-3.73-4.91c-4.03-.91-7.74-2.15-8.09-3.59H75.98Z",
    fill: "#b37361"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PANT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    d: "M54.25,172.71s30.86-2.03,38.36,7.18-7.06,45.42-8.53,65.33c0,0-7.38.77-10.38,0s-5.62-39.39,1.94-48.74c0,0-27.56,6.88-38.77-1.79s12.71-21.83,17.39-21.97Z",
    fill: "#383c4d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_LEG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHOE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    d: "M139.85,222.45,123.79,235.3c-.23-.29-.41-.59-.62-.85l15.97-12.8A4.9,4.9,0,0,1,139.85,222.45Z",
    fill: "#383c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    d: "M119.79,226.42c1.41,1.77.56,4.29,3.35,8.06l16.03-12.82a4.459,4.459,0,0,0-5.85-1.53c-3.77,1.82-7.35,3.21-8.5,2.29l-5.03,4Z",
    fill: "#b37361"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PANT-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    d: "M31.74,195.59c.47,2.62,25.56,10.06,53.51-8.35,0,0,4.33,24.3,32.56,40.39,0,0,6.21-2.77,7.91-6.47,0,0-19.92-25.48-27-46.09-3-8.65-40.45-4.12-45.95-2.35s-23.1,11.33-21.04,22.89Z",
    fill: "#41465a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_HAND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HAND-2",
    d: "M32.74,131.14c6.44,2.15,15.56,21.27,15.56,21.27s10.18.97,25.59,7.44a9.5,9.5,0,0,1-1.68,6.09s-16.94,2.21-25.77,1.29c-2.97-.3-14.27-8.77-20.5-20.44-5.53-10.47-1.12-18.27,6.79-15.65Z",
    fill: "#49549a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ARM-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    d: "M73.78,159.94s4.29-2.26,6.29-1.79a10.409,10.409,0,0,1,4.68,2.77c.23.5,2.03,2.97,2.03,3.53s-5.71.35-6.5.35-6.06.06-7.09-.15.59-4.71.59-4.71Z",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    d: "M80.28,164.8c.79,0,6.5.21,6.5-.35s-1.77-3.03-2.03-3.53a10.182,10.182,0,0,0-4.68-2.77s2.5,3.44.21,6.65",
    fill: "#fab6ad"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    d: "M41.22,112.26c.12,1-2.12,6.03-6.09,9.97-3.53,3.44,11.56,6.09,11.94,6s2.15-5.38,2.53-6.62-8.38-9.35-8.38-9.35Z",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    d: "M49.57,121.61c-.15.53-.77,2.29-1.44,4.09a11.326,11.326,0,0,1-5.15-5.35c-1.53-3-1.44-6.59-1.65-7.44a1.267,1.267,0,0,1,.09-.47c1.32,1.24,8.5,8.06,8.15,9.18Z",
    fill: "#fab6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    d: "M54.22,107.05c.62,2.5,1.18,6.71.32,8.74s-2.35,5.8-2.94,5.97-7.12-.65-8.62-3.47a17.919,17.919,0,0,1-1.77-6.03c-.21-.85,3.35-7.77,7.88-7.62s4.94,1.71,5.12,2.41Z",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    d: "M56.95,105.82c-1.21.5-.29,1.88-2.56,2.12s-2.76-2.59-2.76-2.59a2.25,2.25,0,0,1-1.41,1.5s.62-1.18-.26-1.71a1.024,1.024,0,0,0-1.38.18.852.852,0,0,0-1.13.41.564.564,0,0,0-.04.12c-.41.91.32,1.44,1.29,1.56,0,0,.09,1.33-2.06,1.53s-2.56-1.09-2.56-1.09-.35-.32-.5.62.59,2.44-.91,3.65a4.178,4.178,0,0,1-1.09.71c.73.65.38,2.62-1.33,3.41-2.29,1.09-4,.29-4.21-1.29s.73-.88.5-2a1.636,1.636,0,0,1-2.3-.24,2.326,2.326,0,0,1-.17-.26c-.97-1.62.59-2.12.59-2.12s-.97-1.35-.18-2.29,2.38-.38,2.18-1.06-.77-2.24.15-3.12,2.33-.53,2.53-1-.09-1.18-1.03-.77a2.207,2.207,0,0,1,.94-1.5,3.866,3.866,0,0,1,2.91-.18,2.846,2.846,0,0,1,1.41-2.12,2.567,2.567,0,0,1,3.21.91,1.44,1.44,0,0,1,1.21-.97c1.79-.27,3.29.21,3.65,1.68s3.03-2,4.29,1.03c.27.62-.41,1.09.35,1.59s1-.65.56-.97a2.672,2.672,0,0,1,1.29,1.15,2.215,2.215,0,0,1-.91,3,1.508,1.508,0,0,1-.26.12Z",
    fill: "#b37361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CHAIR-2",
    d: "M9.12,174.74H19.56a15.1,15.1,0,0,1,15.06,15.09v10.44",
    fill: "none",
    stroke: "#ffb000",
    strokeLinecap: "round",
    strokeWidth: 2.37
  }), /*#__PURE__*/React.createElement("g", {
    id: "TABLE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    d: "M125.4,168.27H65.54a1.677,1.677,0,0,0-1.68,1.68h0a1.684,1.684,0,0,0,1.65,1.71h59.88v-3.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    d: "M125.4,168.27H65.54a1.677,1.677,0,0,0-1.68,1.68h0a1.684,1.684,0,0,0,1.65,1.71h59.88",
    fill: "none",
    stroke: "#ffb000",
    strokeWidth: 2.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    d: "M99.49,254.43l9.68-80.98a1.59,1.59,0,0,1,3.12-.06l12.06,80.57",
    fill: "none",
    stroke: "#ffb000",
    strokeLinecap: "round",
    strokeWidth: 2.37
  })), /*#__PURE__*/React.createElement("g", {
    id: "LAPTOP"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_529",
    d: "M73.29,165.18h45.36a1.477,1.477,0,0,1,1.48,1.48h0a1.477,1.477,0,0,1-1.48,1.48H73.29a1.477,1.477,0,0,1-1.48-1.48h0A1.477,1.477,0,0,1,73.29,165.18Z",
    fill: "#fff",
    stroke: "#6562cf",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    d: "M117.11,165.09H83.37a1.156,1.156,0,0,1-1.21-1.08,1.2,1.2,0,0,1,.09-.5l9.53-20.27a3.43,3.43,0,0,1,3.12-1.88h33.74a1.158,1.158,0,0,1,1.21,1.09,1.231,1.231,0,0,1-.09.5l-9.53,20.27a3.43,3.43,0,0,1-3.12,1.88Z",
    fill: "#fff",
    stroke: "#6562cf",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CHAIR-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    d: "M238.12,198.59a2.5,2.5,0,0,1-2.47,2.47H197.09a2.5,2.5,0,0,1,0-4.97h38.56A2.5,2.5,0,0,1,238.12,198.59Z",
    fill: "#fff",
    stroke: "#ffb000",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    d: "M224.33,205.07h-14.5a1.741,1.741,0,0,1-1.74-1.74v-2.26h18v2.24A1.763,1.763,0,0,1,224.33,205.07Z",
    fill: "#fff",
    stroke: "#ffb000",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    width: 3.8,
    height: 30.4,
    transform: "translate(215.21 205.07)",
    fill: "#fff",
    stroke: "#ffb000",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    width: 7.32,
    height: 7.84,
    rx: 3.66,
    transform: "translate(213.42 235.45)",
    fill: "#fff",
    stroke: "#ffb000",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    d: "M233.89,250.37a7.059,7.059,0,0,0-7.06-7.06H207.36a7.035,7.035,0,0,0-7.06,7.01v.06",
    fill: "none",
    stroke: "#6562cf",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    cx: 2.82,
    cy: 2.82,
    r: 2.82,
    transform: "translate(231.22 248.4)",
    fill: "#fff",
    stroke: "#ffb000",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    cx: 2.82,
    cy: 2.82,
    r: 2.82,
    transform: "translate(197.3 248.4)",
    fill: "#fff",
    stroke: "#ffb000",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    cx: 2.82,
    cy: 2.82,
    r: 2.82,
    transform: "translate(214.39 248.4)",
    fill: "#fff",
    stroke: "#ffb000",
    strokeWidth: 2.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "WOMAN"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEGS-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEFT_LEG-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    d: "M180.32,239.28c-1.26,3-2.41,5.44-3.29,7.06s-1.79,8.18-7.77,5.38c-.21-.12,2.35-.76,3.18-6.56.26-2.03.53-3.97.77-5.85a70.454,70.454,0,0,0,7.12-.03Z",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SHOE-2",
    d: "M179.03,254.51s2.38-8.33-.82-9.59c-1.03-.41-2.27.62-2.59,4.12-.29,3.06-4.77,3.56-5.21,1.56,0,0-5.47,1.12-5.47,3.91h14.09Z",
    fill: "#3f4d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    d: "M181.94,239.19a66.138,66.138,0,0,1-10.15-.03s-4.62-48.39-3.94-53.36c.82-6,20.77-11.3,31.09-12.97l1.88-8.62s13.94-.24,21.83-.24c0,0,8.44,15,7.56,24.92s-19.06,7.68-43.33,7.68c0,0,7.41,14.94-4.94,42.62Z",
    fill: "#6562cf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_LEG-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    d: "M202.18,239.51a27.194,27.194,0,0,1-5.56-.06c.62,2.41,1.21,4.74,1.65,6.8.29,1.29-1.59,3.09-2.15,4.38h.06c2.47-.38,5.79,1.97,5.47-1.71s.18-4.62.53-9.42Z",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SHOE-2-2",
    d: "M201.56,246.19c.85,0,2.23,1.56,2.12,4.03a14.293,14.293,0,0,1-.91,4.29h-9.59c.18-2.65,3-3.91,3-3.91,2.47-.38,5.68,1.97,5.32-1.71l.06-2.7Z",
    fill: "#3f4d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    d: "M209.06,177.47s-21.12,3.82-23.53,10.15,8.79,51.57,8.79,51.57c6.5.97,9.83,0,9.83,0,6.77-30.98-1.15-41.27-1.15-41.27,15.74-.65,25.68.82,27.21-9,.5-3.15-3.03-15.09-21.15-11.44Z",
    fill: "#6562cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    d: "M208.71,177.47s-21.15,3.82-23.53,10.15,8.8,51.56,8.8,51.56",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_HAND-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    d: "M204.06,157.21c1.27-2.85-4.33-6.59-10.03-5.09,0,0,1.91-22.92,6.44-25.8s5.41,10.38,5.56,13.62C206.03,139.94,206.85,152.39,204.06,157.21Z",
    fill: "#eaeeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    d: "M203.56,157.88c2.77-2.47-2.94-7.53-9.53-5.77-4.12.65-20.15,4.06-21.65,4.83s-5.71,2.79-6.27,3.44a7.445,7.445,0,0,0-.73,3.27c.04.27.62,1.79.62,1.79a1.051,1.051,0,0,0,.93-1.17.5.5,0,0,0-.02-.12c-.15-1.38,1.09-1.82,1.91-2.18.35-.15,1.24-.09,1.38.41s-1.15,1.18-1.35,1.56a2.082,2.082,0,0,0,.06,1.21s2-1.06,2.38-1.27a11.831,11.831,0,0,0,2.71-3.82s24.71,2.21,29.56-2.18Z",
    fill: "#ffc0b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    d: "M200.5,113.99c-.47-1.12-2.38-6.97.74-9.5s7.24-5.12,12.21-4.71,6.38,7.03,9.21,8.12,6.27-.21,9.53,2.71-.15,7.53,3.18,10,6.53-.65,9.85,3.71c3.79,4.97-1.77,10.74,3.65,11.24,5.97.53,9.59,10.65,7.03,17.38H224.75c-19.91-3.09-24.24-38.95-24.24-38.95Z",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    d: "M202.65,104.14a15.432,15.432,0,0,1,11.56-4.24c5,.24,6.91,5.83,9.77,6.83s6.47-.41,9.79,2.47.15,8.03,3.53,10.44,6.5-.88,9.97,3.47c3.97,4.97-1.38,10.65,4.03,10.97,6,.38,9.91,7.94,6.91,16.56",
    fill: "none",
    stroke: "#ffb000",
    strokeWidth: 2.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "BLOUSE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    d: "M200.74,164.12s-1.77-14.38-2.71-15.15c-2.09-1.68-3.77-4.12-2.88-7.47.5-1.88,4.47-14.44,5.32-15.24s6.44-2.79,6.44-2.79h15.74c1.79.59,7.41,2.62,8.77,4.68,6.59,10.09,8.68,26.21,8.68,26.21h-8.18s-3.94-8.83-5.32-8.91-4.03,18.56-4.03,18.56-8.94,2.5-21.83.12Z",
    fill: "#eaeeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    d: "M200.62,164.12s-1.77-14.38-2.71-15.15c-2.09-1.68-3.88-4.24-3.03-7.59",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    d: "M211.77,125.23s-7.24,13.83-5.44,40.15",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    cx: 0.97,
    cy: 0.97,
    r: 0.97,
    transform: "translate(209.39 134.28)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    cx: 0.97,
    cy: 0.97,
    r: 0.97,
    transform: "translate(208.09 141.3)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    cx: 0.97,
    cy: 0.97,
    r: 0.97,
    transform: "translate(207.95 149.06)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_HAND-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    d: "M239.18,158.29c-4.03,4.24-30.21-1.44-30.21-1.44s-1.35,2.15-2.94,2.24-3.12-.5-3.94.21-1.62,1.85-2.26,2a7.4,7.4,0,0,1-2.3.09c.29-.77.59-1.47.94-2.21-.47.41-1.09,1.12-1.41,1.41a.89.89,0,0,1-1.12.09s1.06-1.59,1.47-2.03a8.686,8.686,0,0,1,2.38-1.74c.71-.23,5.68-2.73,8.12-3.15s23.39-1.79,23.39-1.79c7.54,0,11.3,2.74,7.89,6.32Z",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    d: "M198.32,161.12a16.287,16.287,0,0,1,2-2.88l2.06-1.12",
    fill: "none",
    stroke: "#ffb0af",
    strokeLinecap: "round",
    strokeWidth: 1.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    d: "M199.35,161.09a14.244,14.244,0,0,1,1.85-2.44l2.03-1.12",
    fill: "none",
    stroke: "#ffb0af",
    strokeLinecap: "round",
    strokeWidth: 1.26
  })), /*#__PURE__*/React.createElement("g", {
    id: "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    d: "M213.27,113.82a16.839,16.839,0,0,0,9.38,9.65s-10.06,4.38-15.77,0V114l6.38-.17Z",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    d: "M208.36,124.38a8.318,8.318,0,0,1-1.44-.91V114l6.35-.18a4.869,4.869,0,0,1,.21.53c.65,2.89-1.12,8.92-5.12,10.03Z",
    fill: "#ffc0b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "HEAD",
    d: "M213.12,114.88c-.09,2.24-4.33,7.56-6.65,7.56s-5.53-5.79-5.97-8.44,0-7.47,3.85-7.53c2.35-.03,3.59,2.18,4.29,4.77.88,3.15,3.53,2.44,3.53,2.44s.76-1.73,1.82-.88-.88,2.09-.88,2.09Z",
    fill: "#ffcfc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TABLE-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    d: "M151.35,254.54l6.21-85.42,6.21,85.6",
    fill: "none",
    stroke: "#ffb000",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    d: "M150.79,169.09h81.66a1.91,1.91,0,0,0,1.91-1.91h0a1.936,1.936,0,0,0-1.91-1.94H150.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    d: "M150.79,169.09h81.66a1.91,1.91,0,0,0,1.91-1.91h0a1.936,1.936,0,0,0-1.91-1.94H150.79",
    fill: "none",
    stroke: "#ffb000",
    strokeWidth: 2.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "LAPTOP-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    d: "M183.15,136.2H150.21a2.268,2.268,0,0,0-2.27,2.27h0a2.069,2.069,0,0,0,.15.77l8.29,22.59h38.59l-8.59-23.35a3.47,3.47,0,0,0-3.24-2.27Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    d: "M183.44,136.2H150.35a2.324,2.324,0,0,0-2.21,2.43,2.2,2.2,0,0,0,.15.72l7.21,20.88a2.274,2.274,0,0,0,2.12,1.59H194.6l-8-23.27a3.37,3.37,0,0,0-3.15-2.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    d: "M182.06,137.76H149a2.177,2.177,0,0,0-2.21,2.14,2.386,2.386,0,0,0,.15.83l7.21,19.62a2.224,2.224,0,0,0,2.09,1.47h37l-8-21.86a3.42,3.42,0,0,0-3.17-2.21Z",
    fill: "#e2e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    d: "M156.29,161.83h63.13a3.318,3.318,0,0,1,3.32,3.29H159.61a3.314,3.314,0,0,1-3.32-3.3h0Z",
    fill: "#fff",
    stroke: "#6562cf",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    d: "M183.15,136.2H150.21a2.268,2.268,0,0,0-2.27,2.27h0a2.069,2.069,0,0,0,.15.77l8.29,22.59h38.59l-8.59-23.35a3.47,3.47,0,0,0-3.24-2.27Z",
    fill: "none",
    stroke: "#6562cf",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    cx: 2.12,
    cy: 2.62,
    rx: 2.12,
    ry: 2.62,
    transform: "translate(165.678 150.696) rotate(-48)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    cx: 2.12,
    cy: 2.62,
    rx: 2.12,
    ry: 2.62,
    transform: "translate(166.451 149.929) rotate(-48)",
    fill: "none",
    stroke: "#6562cf",
    strokeWidth: 2.11
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    width: 23.25,
    height: 15.31,
    rx: 2,
    transform: "translate(223.84 23.52)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    x2: 10.92,
    y2: 7.19,
    transform: "translate(224.54 25.13)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    x1: 11.63,
    y2: 7.67,
    transform: "translate(235.46 24.65)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    cx: 3.34,
    cy: 3.34,
    r: 3.34,
    transform: "translate(243.88 20.31)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(246 25.12)",
    fill: "#fff",
    fontSize: 4,
    fontFamily: "Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    d: "M190.32,38.95h0a1.878,1.878,0,0,1,1.85,1.88v6.41a1.852,1.852,0,0,1-1.85,1.85h0a1.878,1.878,0,0,1-1.88-1.85V40.83A1.878,1.878,0,0,1,190.32,38.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    cx: 3.74,
    cy: 3.74,
    r: 3.74,
    transform: "translate(186.58 52.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    d: "M190.32,44.92a11.237,11.237,0,0,0-11.27,11.21v.06h22.53a11.269,11.269,0,0,0-11.27-11.27Z",
    fill: "#b8b6b6"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    y1: 40.86,
    transform: "translate(190.32 1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.98660256b147ee6ae8c7e1163ad64088.svg";
export { ForwardRef as ReactComponent };